const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tif', 'tiff', 'svg']
const PDF_EXT = ['pdf']
const DOC_EXT = ['doc', 'docx', 'wps', 'rtf', 'txt']
const EXCEL_EXT = ['xls', 'xlsx', 'csv']
const AUDIO_EXT = ['mp3', 'wav', 'flac', 'aac', 'ogg', 'm4a']
const VIDEO_EXT = ['mp4', 'avi', 'mov', 'wmv', 'mkv', 'flv', 'webm']
const ARCHIVE_EXT = ['zip', 'rar', '7z', 'tar', 'gz', 'bz2']

function getExtension(fileName) {
  if (!fileName || !fileName.includes('.')) {
    return ''
  }
  return fileName.split('.').pop().toLowerCase()
}

export function isPdfFile(file) {
  if (!file) return false
  const ext = getExtension(file.name)
  return file.type === 'PDF' || PDF_EXT.includes(ext)
}

export function getFileIconMeta(file) {
  const ext = getExtension(file.name)
  const typeLabel = file.type || ''

  if (typeLabel === '图片' || IMAGE_EXT.includes(ext)) {
    return { iconClass: 'el-icon-picture-outline', kind: 'image' }
  }
  if (typeLabel === 'PDF' || PDF_EXT.includes(ext)) {
    return { iconClass: 'el-icon-document', kind: 'pdf' }
  }
  if (typeLabel === '压缩包' || ARCHIVE_EXT.includes(ext)) {
    return { iconClass: 'el-icon-folder-opened', kind: 'zip' }
  }
  if (typeLabel === '视频' || VIDEO_EXT.includes(ext)) {
    return { iconClass: 'el-icon-video-camera', kind: 'video' }
  }
  if (typeLabel === '音频' || AUDIO_EXT.includes(ext)) {
    return { iconClass: 'iconfont icon-musiclist', kind: 'audio' }
  }
  if (DOC_EXT.includes(ext)) {
    return { iconClass: 'iconfont icon-doc', kind: 'doc' }
  }
  if (EXCEL_EXT.includes(ext)) {
    return { iconClass: 'iconfont icon-excel', kind: 'excel' }
  }
  return { iconClass: 'el-icon-document', kind: 'file' }
}
